import React from 'react';
import { MytripsLoginTranslationsPageProvider } from './TranslationsPageProvider';
import { PortalAsync } from '@edreamsodigeo/frontend-core';
import { MyTripsLoginValueProposition, MyTripsLoginTrackingProvider as SupportAreaMyTripsLoginTrackingProvider } from '@edreamsodigeo/frontend-support-area';
import { useUser, IncentivizeMyTripsLogin, ModalScreenProvider, MytripsLoginAuthFlow, GoogleIdentityProvider } from '@edreamsodigeo/frontend-user-authentication';
import { MyTripsLoginPage, useGetSuccessAuthRedirection, MytripsLoginTrackingPageProvider } from '@edreamsodigeo/frontend-manage-my-booking';
import { BFFSupportAreaProvider } from '../../providers/BackendForFrontendProvider';
export const MyTripsLoginComponent = () => {
  const loginProps = useUser();
  const redirectionUrl = useGetSuccessAuthRedirection();
  return /*#__PURE__*/React.createElement(GoogleIdentityProvider, null, /*#__PURE__*/React.createElement(MyTripsLoginPage, {
    loginProps: loginProps,
    userAuthentication: /*#__PURE__*/React.createElement(ModalScreenProvider, null, /*#__PURE__*/React.createElement(MytripsLoginAuthFlow, {
      successRedirectionUrl: redirectionUrl
    })),
    incentivizeUserAuthentication: /*#__PURE__*/React.createElement(ModalScreenProvider, null, /*#__PURE__*/React.createElement(IncentivizeMyTripsLogin, {
      successRedirectionUrl: redirectionUrl
    }))
  }));
};
const MytripsLoginValuePropositionComponent = () => /*#__PURE__*/React.createElement(BFFSupportAreaProvider, null, /*#__PURE__*/React.createElement(SupportAreaMyTripsLoginTrackingProvider, null, /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "sa-value-proposition-banner",
  parentId: "mytripslogin_page_parent",
  Component: MyTripsLoginValueProposition
})));
const MytripsLogin = () => /*#__PURE__*/React.createElement(MytripsLoginTranslationsPageProvider, null, /*#__PURE__*/React.createElement(MytripsLoginTrackingPageProvider, null, /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "mytripslogin-page-container",
  parentId: "mytripslogin_page_parent",
  Component: MyTripsLoginComponent
}), /*#__PURE__*/React.createElement(MytripsLoginValuePropositionComponent, null)));
export default MytripsLogin;